// Source: http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript

export function generateReferralCode() {
  /* Be aware that UUID uniqueness relies heavily on the underlying random number
  generator (RNG). The solution above uses Math.random() for brevity, however
  Math.random() is not guaranteed to be a high-quality RNG. */
  return Math.random().toString(36).substring(2, 15);
}
